export enum AllocationViewAllocateType {
  Manual = 'MANUAL',
  Auto = 'AUTO',
  Rule = 'RULE',
}

export enum AllocationViewMode {
  List = 'LIST',
  Calendar = 'CALENDAR',
  DriverView = 'DRIVER_VIEW',
}

export enum AllocationDriverPhoneType {
  LoanerPhone = 'LOANER_PHONE',
  Private = 'PRIVATE',
}

export const ALLOCATION_TERMINAL_VIEW_DEFAULT_PAGE_SIZE = 1000;

export const AllocationViewFilterConfigurationStorageKey = 'allocation-view-filter-configuration';

export const AllocationViewHubConfigurationStorageKey = 'allocation-view-hub-configuration';
